import TagManager from 'react-gtm-module';

interface TrackQuickAddClickProps {
  /** Product name shown on the card (`link_text`). */
  linkText: string;
  /** Product PDP URL, so the PDP can be traced from the click (`link_url`). */
  linkUrl: string;
  /**
   * URL of the PLP the click fired from (`interaction_location`) — path +
   * query, no origin, matching the `item_list_name` capture in Quick Add's
   * `add_to_cart` (ED-460).
   */
  interactionLocation: string;
}

/**
 * Fire the GA4 `user_interaction` / `click_quick_atc` event when a shopper
 * opens Quick Add from a PLP card (ED-461). Mirrors the `interaction` field
 * shape used by `trackNavClick`.
 */
export const trackQuickAddClick = ({
  linkText,
  linkUrl,
  interactionLocation,
}: TrackQuickAddClickProps) => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_name: 'click_quick_atc',
      interaction: {
        interaction_location: interactionLocation,
        link_text: linkText,
        link_url: linkUrl,
      },
    },
  });
};

export default trackQuickAddClick;
